import userAgentParser from 'ua-parser-js'

/**
 * Return true/false if the user is on iOS
 */
export const isIOS = (userAgent?: string) =>
    userAgentParser(userAgent)?.os?.name === 'iOS'
